import { Link as LinkS } from 'react-scroll';
import styled from 'styled-components';

export const Nav = styled.nav`
  background: 'transparent';
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.8rem;
  position: sticky;
  top: 0;
  z-index: 10;

  @media screen and (max-width: 960px) {
    transition: 0.8s all ease;
  }
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 80px;
  z-index: 1;
  width: 100vw;
  padding: 0 24px;
  max-width: 1100px;
`;

export const NavLogo = styled.div`
  padding-top: 10px;
  z-index: 4;
  height: 30px;
`;

export const NavLogoImg = styled.img`
  z-index: 4;
  width: 300px;
`;

export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 980px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin-right: 50px;

  @media screen and (max-width: 980px) {
    display: none;
  }
`;

export const NavItem = styled.li`
  height: 80px;
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;

  @media screen and (max-width: 980px) {
    display: none;
  }
`;

export const NavLinksS = styled(LinkS)`
  color: white;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;

  &:hover {
    color: #8c68e8;
    transition: all 0.2s ease-in-out;
  }

    &:active {
    color: #05c865;
  }
`; 

export const NavLinks = styled.a`
  color: #17fed0;
  display: flex;
  align-items: center;
  text-decoration: none;
  font-family: 'Joystix Monospace';
  font-size: 22px;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;

  &:hover {
    color: #F401f9;
    transition: all 0.2s ease-in-out;
  }

  &:active {
    color: red;
  }
`;

export const NavBtnConnect = styled.button`
  border-radius: 50px;
  background: #000;
  white-space: nowrap;
  padding: 2px 40px;
  color: #17fed0;
  font-size: 22px;
  font-family: 'Cursed Timer';
  outline: none;
  border: solid 3px #17fed0;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    color: #F401f9;
    border: solid 3px #F401f9;
  }

  &:active {
    color: red;
    border: solid 3px red;
  }
`;

export const NavBtnConnected = styled.div`
  border-radius: 50px;
  background: #000;
  white-space: nowrap;
  padding: 2px 28px;
  color: #05c865;
  font-size: 22px;
  font-family: 'Cursed Timer', cursive;
  outline: none;
  border: solid 3px #05c865;
  text-decoration: none;
`

export const NavMusic = styled.audio`
  left: 5px;
  color: transparent;
`
